var map = {
	"./10276612_4421959.svg": 1585,
	"./10780595_19199559.svg": 467,
	"./155629914_6d44cb86-d4d8-478d-ab1d-c3b69b049c1d.svg": 4826,
	"./15917681_5679655.svg": 5417,
	"./21743679_6500556.svg": 7824,
	"./24784485_2020_11_28_spa03.svg": 4840,
	"./26432841_miningindustry_online_1.svg": 3148,
	"./26477198_diplomat_online1.svg": 6597,
	"./26477270_critic_online_1.svg": 9883,
	"./28158353_jobinterview_online_2.svg": 2200,
	"./28772290_7484893.svg": 6400,
	"./3759883_35675.svg": 8595,
	"./4463224_2388717.svg": 2693,
	"./digital1.webp": 5112,
	"./digital2.webp": 3717,
	"./digital3.webp": 6714,
	"./digital4.webp": 9895,
	"./digital5.webp": 5860,
	"./digital6.webp": 385,
	"./digital7.webp": 4278,
	"./digital8.webp": 2435,
	"./digital9.webp": 4944,
	"./famer.svg": 8230,
	"./ram_slide1.webp": 8430,
	"./ram_slide2.webp": 8127,
	"./ram_slide3.webp": 6540
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8603;
module.exports = webpackAsyncContext;